export function getBoundProperty<T, K extends keyof T>(target: T, prop: K): T[K] {
  const value = target[prop];

  if (typeof value === 'function') {
    // Binding every time is faster than a WeakMap lookup using the target and function value.
    return value.bind(target);
  }

  return value;
}
